module.exports = __webpack_public_path__ + "img/2294741.png";